import * as core from '../../../../../../../core'

import { query } from './awards-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.awards.widgets.awards-table',
    description: 'Awards',
    name: 'Awards',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
